import React, { useState } from 'react';
import { Select, Input, Button, Divider, Space, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import api from '../utils/api';

const { Option } = Select;

// Company dropdown that lets admin/manager type a brand-new firm/company name
// inline (without leaving the form). New firm is saved and auto-selected.
export default function CompanySelect({
  companies = [],
  onCompaniesChange,
  value,
  onChange,
  placeholder = 'Select company',
  allowClear = false,
  style = { width: '100%' }
}) {
  const [name, setName] = useState('');
  const [adding, setAdding] = useState(false);

  let canAdd = false;
  try {
    const u = JSON.parse(localStorage.getItem('user') || '{}');
    canAdd = ['admin', 'manager'].includes(u.role);
  } catch (e) { canAdd = false; }

  const addCompany = async () => {
    const n = name.trim();
    if (!n) return;
    setAdding(true);
    try {
      const res = await api.post('/companies', { name: n });
      message.success(`Firm "${n}" added`);
      setName('');
      if (onCompaniesChange) await onCompaniesChange();
      if (onChange) onChange(res.data.id);
    } catch (err) {
      message.error(err.response?.data?.error || 'Failed to add firm');
    }
    setAdding(false);
  };

  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      allowClear={allowClear}
      style={style}
      showSearch
      optionFilterProp="children"
      dropdownRender={canAdd ? (menu) => (
        <>
          {menu}
          <Divider style={{ margin: '6px 0' }} />
          <Space style={{ padding: '0 8px 6px', width: '100%' }}>
            <Input
              placeholder="New firm / company name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={(e) => e.stopPropagation()}
              onPressEnter={(e) => { e.preventDefault(); addCompany(); }}
            />
            <Button type="primary" icon={<PlusOutlined />} loading={adding} onMouseDown={(e) => e.preventDefault()} onClick={addCompany}>Add</Button>
          </Space>
        </>
      ) : undefined}
    >
      {companies.map(c => <Option key={c.id} value={c.id}>{c.name}</Option>)}
    </Select>
  );
}
